/**
 * 017: composes `EmptyState` (packages/theme/src/domain/empty-state.tsx), the rule-bearing wrapper
 * around rizzui's `Empty` — the same "no rows" illustration
 * vendor/isomorphic/packages/isomorphic-core/src/components/table/index.tsx (`MainTable`) renders
 * for its own empty state. The vendor template ships no dedicated 404 page for a shell that stays
 * mounted (its own `not-found` pages are full-screen, outside any layout); this is the nearest
 * copied primitive for a not-found state rendered inside the persistent `HydrogenLayout`.
 *
 * Only the data, columns and labels are ours. The screen-to-template mapping is
 * specs/017-isomorphic-theme-only/contracts/screen-map.md.
 */
import { Link } from "react-router-dom";
import { PiCompassDuotone as Compass } from "react-icons/pi";
import { Button } from "rizzui";
import { EmptyState } from "@steelyard/theme";

/** Ported from apps/admin/app/not-found.tsx. */
export default function NotFound() {
  return (
    <div className="mx-auto max-w-lg py-10">
      <EmptyState
        icon={<Compass aria-hidden className="size-5" />}
        title="No screen answers this address"
        action={
          
            <Link to="/"><Button as="span">Back to the dashboard</Button></Link>
        }
      >
        Check the link, or pick a section from the navigation. Sections you have permission for but which are not
        built yet are listed on the dashboard.
      </EmptyState>
    </div>
  );
}
